import Filters, { registerModuleFilters } from '@/utils/input/filters';
import { CoreEnums } from '@/utils/domain/constants';
import { createEnumOptions } from '@/utils/core/data-transformation';
import { getEnumNamespace } from '@/utils/infrastructure';

const { UserFilter, BaseFilters, DateFilter } = Filters;
const { DelegationType, DelegationStatus } = CoreEnums;

// Badge configurations for table rendering
export const delegationStatus = {
  [DelegationStatus.Pending]: {
    id: 'delegations.delegationStatus.pending',
    color: 'warning',
  },
  [DelegationStatus.Execution]: {
    id: 'delegations.delegationStatus.execution',
    color: 'execution',
  },
  [DelegationStatus.Finished]: {
    id: 'delegations.delegationStatus.finished',
    color: 'success',
  },
  [DelegationStatus.Voided]: {
    id: 'delegations.delegationStatus.voided',
    color: 'voided',
  },
  [DelegationStatus.Error]: {
    id: 'delegations.delegationStatus.error',
    color: 'error',
  },
};

export const delegationType = {
  [DelegationType.Temporary]: {
    id: 'delegations.delegationType.temporary',
    color: 'warning',
  },
  [DelegationType.Definitive]: {
    id: 'delegations.delegationType.definitive',
    color: 'success',
  },
};

// Filter configurations
const DelegationTypeFilter = {
  ...BaseFilters.EnumFilter,
  name: 'type',
  label: 'global.type',
  enumNamespace: getEnumNamespace(DelegationType),
  enumSource: DelegationType,
  options: createEnumOptions(DelegationType, 'delegations.delegationType'),
};

const DelegationStatusFilter = {
  ...BaseFilters.EnumFilter,
  name: 'status',
  label: 'global.text.status',
  enumNamespace: getEnumNamespace(DelegationStatus),
  enumSource: DelegationStatus,
  options: createEnumOptions(DelegationStatus, 'delegations.delegationStatus'),
};

const StartDateFilter = {
  ...DateFilter,
  label: 'delegations.form.startDate',
  name: 'start',
};

const EndDateFilter = {
  ...DateFilter,
  label: 'delegations.form.endDate',
  name: 'end',
};

const CreatedDateFilter = {
  ...DateFilter,
  label: 'global.text.createdDate',
};

const UpdatedDateFilter = {
  ...DateFilter,
  label: 'global.text.updatedDate',
  name: 'updatedDateRange',
};

export const filtersConfig = [
  DelegationTypeFilter,
  DelegationStatusFilter,
  { ...UserFilter, name: 'sourceUserId' },
  StartDateFilter,
  EndDateFilter,
  CreatedDateFilter,
  UpdatedDateFilter,
];

registerModuleFilters('delegations', filtersConfig);
